import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../base.graphql';

export const citizenServicesCategoryField = `
id
existenceUniqueId
serviceExistenceSource
serviceExistenceSourceLink
`;

export const GET_CITIZEN_SERVICES_EXISTANCE_SOURCE = gql`
query CitizenGetServicesExistanceSource($filtering:ServiceExistenceSourcesFilterInputObject){
    citizenGetServicesExistanceSource(filtering:$filtering){
    ${baseResponseGraphqlField}
    data {
      ${citizenServicesCategoryField}
    }
  }
}
`;
